import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { Button, Grid, MenuItem, Select } from "@mui/material";
import TranslationWrapper from "../TranslationWrapper/TranslationWrapper";
import customPaginationStyle from "../Table2/customPaginationStyle";
import { withStyles } from "tss-react/mui";
import cx from "classnames";

function Pagination(props) {
  const maxNumberOfButtons = 9;

  const totalPages = useMemo(() => {
    return Math.max(props.totalPages, props.page + 1);
  }, [props.totalPages, props.page]);

  const pageButtons = useMemo(() => {
    let main = [];
    let prefix = [];
    let suffix = [];

    if (props.page > 0) {
      prefix.push({
        value: props.page,
        text: <TranslationWrapper tDefault={"Vorige"} tKey={"global.pagination.vorige"} />,
      });
    }

    let start = 1;

    if (totalPages > maxNumberOfButtons && props.page - 4 > 0) {
      prefix.push({ value: 1, text: 1 });
      prefix.push({ text: "...", disabled: true });
      start = props.page - 2;
    }

    let end = totalPages;
    if (totalPages > maxNumberOfButtons && props.page <= totalPages - 3) {
      suffix.push({ text: "...", disabled: true });
      suffix.push({
        value: totalPages,
        text: totalPages,
      });
      end = props.page + (props.page - 2 > 0 ? 2 : 5);
    }

    if ((totalPages && props.page + 1 !== totalPages) || !props.paginationData?.first_page_url) {
      suffix.push({
        value: props.page + 2,
        text: <TranslationWrapper tDefault={"Volgende"} tKey={"global.pagination.volgende"} />,
      });
    }

    if (props.paginationData?.first_page_url != null) {
      let i;
      for (i = start; i < end + 1; i++) {
        main.push({ value: i, text: i, active: i === props.page + 1 });
      }
    } else {
      main.push({ value: props.page + 1, text: props.page + 1, active: true });
    }

    if (!totalPages) {
      main.push({ value: props.page, text: props.page, active: true });
    }

    //Generate pages
    return [...prefix, ...main, ...suffix];
  }, [props.page, totalPages, props.paginationData]);

  const { classes } = props;

  return (
    <>
      <Grid container item justify={"center"} md={9} xs={12}>
        {pageButtons.map((obj) => {
          const classNames = [classes.paginationLink];
          if (obj.active) {
            classNames.push(classes.primary);
          }
          if (obj.disabled) {
            classNames.push(classes.disabled);
          }
          return (
            <Button
              //  GEEN KEY toevoegen!!!!!
              className={cx(classNames)}
              disabled={obj.active}
              onClick={(e) => props.onPageChange(e, obj.value - 1)}
            >
              {obj.text}
            </Button>
          );
        })}
      </Grid>
      <Grid item md={3} xs={12}>
        <Select onChange={props.onRowsPerPageChange} style={{ width: "100%" }} value={props.rowsPerPage}>
          {props.rowsPerPageOptions.map((option) => (
            <MenuItem
              //  GEEN KEY toevoegen!!!!!
              value={option}
            >
              {option} <TranslationWrapper tKey={"Records"} />
            </MenuItem>
          ))}
        </Select>
      </Grid>
    </>
  );
}

Pagination.propTypes = {
  totalPages: PropTypes.number.isRequired,
  totalItems: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  rowsPerPageOptions: PropTypes.array.isRequired,
  onRowsPerPageChange: PropTypes.func.isRequired,
};

export default withStyles(Pagination, customPaginationStyle);
